const checkSuccess = (res, apiKey, msg, store) => {
	if (res?.data?.[apiKey]?.status !== "success") {
		store.dispatch("addMessage", {
			message: {
				type: "error",
				text: msg
			}
		})
		return false
	}
	return true
}

export { checkSuccess }
